import { progressiveComponent } from 'site-modules/shared/components/progressive-component/progressive-component';
import { RenderOnInteraction } from 'site-modules/shared/components/render-on-interaction/render-on-interaction';

/* Seo Components */
import { SeoFaq } from 'site-modules/shared/components/faq/seo-faq';

export default {
  FaqLazy: progressiveComponent({
    SEOComponent: SeoFaq,
    fullComponent: {
      loader: () => import(/* webpackChunkName: "type-faq" */ 'site-modules/shared/components/faq/faq'),
      name: 'Faq',
    },
    Renderer: RenderOnInteraction,
    interactionEvents: ['keydown', 'scroll', 'mousedown', 'touchstart', 'mousemove'],
  }),
};
